import { removeSpecialCharacters } from './string'

const converTextToInt = (text: string) => parseInt(text)

const convertMaskToInt = (text: string) => converTextToInt(removeSpecialCharacters(text))

const formatToPTBRNumber = (number: number, symbol = true) =>
  number?.toLocaleString('pt-br', {
    currency: 'BRL',
    minimumFractionDigits: 2,
    style: symbol ? 'currency' : 'decimal',
  })

const numberToDecimalString = (value: number): string => {
  if (!value) return '0'

  return value.toLocaleString('pt-BR', { style: 'decimal' })
}

const zeroPad = (num: number, places: number) => String(num).padStart(places, '0')

const checkIfIsTypeOfNumber = (value: unknown) => typeof value === 'number'

const checkIfIsNumber = (value: unknown): boolean => {
  if (typeof value === 'number' || typeof value === 'string') {
    return !isNaN(Number(value))
  }

  return false
}

const ensureNonNegative = (value: number): number => {
  return value < 0 ? 0 : value
}

export {
  checkIfIsNumber,
  checkIfIsTypeOfNumber,
  converTextToInt,
  convertMaskToInt,
  ensureNonNegative,
  formatToPTBRNumber,
  numberToDecimalString,
  zeroPad,
}
